export default __webpack_public_path__ + "static/media/weather.63a4b56e.jpg";